import Api from '../Api';

import { url } from './config';
import { ServiceStartDateOption } from './types';

const api = new Api<ServiceStartDateOption>(url);

export default api;
